import modalController from 'src/decorators/ModalController'
import createFlow from 'src/utils/flow/createFlow'

const createModalFlow = (flowConfig) => {
  const flow = createFlow(flowConfig)

  flow.events.on('transition', ({ fromState, toState, event, meta }) => {
    const fromModal = fromState.value
    const toModal = toState.value
    const { onFinished, onExit } = meta
    const { data } = event

    if (fromModal !== toModal) {
      if (fromModal === 'entry') {
        modalController.showModal(toModal, data)
      } else if (toModal === 'exit') {
        modalController.closeModal(fromModal, () => typeof onExit === 'function' && onExit(data))
      } else if (toModal === 'finish') {
        modalController.closeModal(fromModal, () => typeof onFinished === 'function' && onFinished(data))
      } else {
        modalController.closeModal(fromModal, () => modalController.showModal(toModal, data))
      }
    }
  })

  return flow
}

export default createModalFlow
